var _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNotFound = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 566.93 566.93",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "b5c4b56b-161c-42a1-be22-8a76c6892e3d"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 283.46,
    cy: 283.46,
    r: 283.46,
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "f17e3ceb-ab29-4137-af28-72228e9ac328",
    "data-name": "Copy"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.05
    }
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 283.46,
    cy: 283.46,
    r: 283.46
  }))), /*#__PURE__*/React.createElement("circle", {
    cx: 282.12,
    cy: 278.7,
    r: 206.74,
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 433.04,
    cy: 380.21,
    r: 66.47,
    style: {
      fill: "#73be00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.43,411.26c0-4.62,3.72-8.8,9.36-8.8,6.09,0,9.47,3.84,9.47,8.91a8.79,8.79,0,0,1-9.24,8.91C428.7,420.28,425.43,416.22,425.43,411.26ZM429.56,340H440.7a2.66,2.66,0,0,1,2.66,2.66v16a1.21,1.21,0,0,1,0,.19l-2.52,35.54a2.67,2.67,0,0,1-2.66,2.48h-6a2.67,2.67,0,0,1-2.66-2.47l-2.63-35.55V342.66A2.66,2.66,0,0,1,429.56,340Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#b5c4b56b-161c-42a1-be22-8a76c6892e3d)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M533.26,149.36a119.32,119.32,0,0,0,6.88-10.82",
    style: {
      fill: "none",
      stroke: "#464646",
      strokeMiterlimit: 10,
      strokeWidth: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.63,210.42s57.67-17,91.42-55.42c.26-.29.34-.68.59-1,.59-.7,1.89-2.27,3.62-4.67",
    style: {
      fill: "none",
      stroke: "#464646",
      strokeMiterlimit: 10,
      strokeWidth: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.44,225.37l-40.81,16.45s-6.8,3.74-5,9.22c0,0,1,7,8.44,5L319.52,239",
    style: {
      fill: "#686767"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "314.4 241.02 320.25 238.66 314.84 225.21 308.99 227.57",
    style: {
      fill: "#686767"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "333.34 288.01 339.19 285.66 333.77 272.21 327.92 274.57",
    style: {
      fill: "#686767"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.12,272.07l-41.44,16.7s-6.91,3.78-5.1,9.27c0,0,1,7,8.52,5l43.09-17.36",
    style: {
      fill: "#686767"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.91,190.47s46.67,26,86.59,7.75l11,27.39s-49,24.14-56.4,67.21Z",
    style: {
      fill: "gray",
      stroke: "gray",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 430.94,
    y: 193.24,
    width: 13.38,
    height: 34.35,
    transform: "translate(-46.93 178.79) rotate(-21.94)",
    style: {
      fill: "#b9b9b9",
      stroke: "#b9b9b9",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 325.85,
    y: 193,
    width: 34.94,
    height: 110.34,
    transform: "translate(-67.87 146.29) rotate(-21.94)",
    style: {
      fill: "#b9b9b9",
      stroke: "#b9b9b9",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108,321.09s-47.07.66-87.2,54.64q-3.49,4.69-6.54,9.68",
    style: {
      fill: "none",
      stroke: "#464646",
      strokeMiterlimit: 10,
      strokeWidth: 11
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.38,299.86l85.23-54,23.65,98.29-100-7.41Z",
    style: {
      fill: "gray",
      stroke: "gray",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215.78,
    y: 235,
    width: 34.94,
    height: 110.34,
    transform: "translate(-61.4 62.61) rotate(-13.53)",
    style: {
      fill: "#b9b9b9",
      stroke: "#b9b9b9",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.04,
    y: 303.11,
    width: 13.38,
    height: 34.35,
    transform: "translate(-71.73 35.72) rotate(-13.53)",
    style: {
      fill: "#b9b9b9",
      stroke: "#b9b9b9",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  })), /*#__PURE__*/React.createElement("line", {
    x1: 216.66,
    y1: 180.03,
    x2: 190.65,
    y2: 153.63,
    style: {
      stroke: "#c3c3c3",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 9
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 249.63,
    y1: 158.65,
    x2: 237.81,
    y2: 123.29,
    style: {
      stroke: "#c3c3c3",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 9
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 332.27,
    y1: 427.16,
    x2: 320.44,
    y2: 391.8,
    style: {
      stroke: "#c3c3c3",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 9
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 288.52,
    y1: 159.39,
    x2: 294.43,
    y2: 122.54,
    style: {
      stroke: "#c3c3c3",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 9
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 279.16,
    y1: 434.86,
    x2: 285.08,
    y2: 398.01,
    style: {
      stroke: "#c3c3c3",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 9
    }
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNotFound);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/not-found.240cb50dcb4085f48d584d7eec41832e.svg";